export enum PostReportReason {
  MYPOST = "mypost",
  CSAM = "csam",
  NCII = "ncii",
  INCEST = "incest",
  BEASTIALITY = "beastiality",
  DMCA = "dmca",
  OTHER = "other",
}

export const PostReportMessageMaxLength = 500;
export const PostReportOtherReasonMaxLength = 500;
